var angular = require('angular');
var _module = require('../../components/module');
var SockJS = require('sockjs-client');

_module
    .provider('socketFactory', [
        function () {
            // when forwarding events, prefix the event name
            var ioSocket;

            // expose to provider
            this.$get = ['$timeout', function ($timeout) {
                var asyncAngularify = function (socket, callback) {
                    return callback ? function () {
                        var args = arguments;
                        $timeout(function () {
                            callback.apply(socket, args);
                        }, 0);
                    } : angular.noop;
                };

                return function socketFactory(options) {
                    options = options || {};
                    var socket = options.socket || new SockJS(options.url);

                    var wrappedSocket = {
                        callbacks: {},
                        setHandler: function (event, callback) {
                            socket['on' + event] = asyncAngularify(socket, callback);
                            return this;
                        },
                        removeHandler: function (event) {
                            delete socket['on' + event];
                            return this;
                        },
                        send: function () {
                            return socket.send.apply(socket, arguments);
                        },
                        close: function () {
                            return socket.close.apply(socket, arguments);
                        }
                    };

                    return wrappedSocket;
                };
            }];
        }
    ])

    .factory('realTime', ['$log', 'socketFactory', '$rootScope', function ($log, socketFactory, $rootScope) {
        var that = null;
        var reconnection = {
            timeout: null,
            // reconnection interval in seconds
            interval: 1
        };

        // current instance of the socket
        var currSock = null;
        // current user
        var currUser = null;
        // current room
        var currRoom = null;
        // maintain list of callbacks for realTime.onMessage handlers
        var onMessageCallbacks = [];
        // maintain list of callbacks for realTime.on handlers
        var onCallbacks = {};
        // maintain list of callbacks for realTime.once handlers
        var onceCallbacks = {};
        // message queue for messages sent before connection is established
        var messageQueue = [];

        return {
            getRoom: function () {
                return currRoom;
            },
            isConnected: false,
            reconnect: function () {
                // try reconnecting every (x) seconds
                reconnection.timeout = window.setTimeout(this.connect,
                    reconnection.interval * 1000);
                // maximum reconnection timeout is set to 30 seconds
                // until then, keep increasing the interval
                reconnection.interval += reconnection.interval < 30 ? reconnection.interval : 0;
            },
            ident: function (user, room) {
                if(that === null) that = this;
                if(user === null || angular.isUndefined(user)) {
                    $log.debug("user not logged in, don't ident");
                }else {
                    $log.debug('identing...');
                    var identObj = {
                        mtype: 'ident',
                        uid: user
                    };
                    if(angular.isDefined(room) && room !== null) identObj.room = room;
                    that.sendMessage(identObj);
                    $rootScope.$broadcast('socket:idented', user);
                    // after identing, flush the messageQueue to send any unsent messages
                    that.flushMessageQueue();
                }
            },

            connect: function (user, room) {
                if(that === null) that = this;
                if(angular.isDefined(user)) currUser = user;
                if(angular.isDefined(room)) currRoom = room;
                // call this to connect to the sockjs server
                var sockjs = new SockJS('/sockjs');
                currSock = socketFactory({
                    socket: sockjs
                });

                currSock.setHandler('open', function (message) {
                    if(reconnection.timeout !== null) {
                        // reset connection interval back to 1
                        reconnection.interval = 1;
                        // clear reconnection timeout if the socket is connected finally
                        window.clearTimeout(reconnection.timeout);
                    }
                    that.isConnected = true;
                    that.ident(currUser, currRoom);
                    $rootScope.$broadcast('socket:connected', currSock, message);
                });

                currSock.setHandler('message', function (message) {
                    // on receiving a message from the server process it
                    // $log.debug('rtService => user', message);

                    var data = {};

                    try {
                        data = JSON.parse(message.data);
                        // broadcast data on the rootscope
                        $rootScope.$broadcast('socket:message', data);
                        //iterate through each onMessageCallbacks and send them the data
                        onMessageCallbacks.forEach(function (cb) {
                            cb(data);
                        });

                        if(onCallbacks.hasOwnProperty(data.mtype)) {
                            onCallbacks[data.mtype].forEach(function (cb) {
                                cb(data);
                            });
                        }

                        if(onceCallbacks.hasOwnProperty(data.mtype)) {
                            onceCallbacks[data.mtype].forEach(function (cb) {
                                cb(data);
                            });

                            onceCallbacks[data.mtype].length = 0;
                        }

                    } catch(e) {
                        $log.error('sockjs message', e);
                    }
                });

                currSock.setHandler('close', function (message) {
                    $rootScope.$broadcast('socket:disconnected', message);
                    $log.debug('socket disconnected. reconnecting in ' + reconnection.interval + '...');
                    that.isConnected = false;
                    // auto reconnection on disconnect
                    that.reconnect();
                });
                return currSock;
            },

            sendMessage: function (data) {
                if(that.isConnected) {
                    $log.debug('user => rtService', data);
                    currSock.send(JSON.stringify(data));
                } else {
                    messageQueue.push(data);
                }
            },

            flushMessageQueue: function () {
                // send any messages that were queued because the connection wasn't complete
                if(!that.isConnected) {
                    $log.error('the socket is still not connected, not flushing queue');
                    return;
                } else {
                    while(messageQueue.length > 0) {
                        var data = messageQueue.shift();
                        that.sendMessage(data);
                    }
                }
            },

            onMessage: function (cb) {
                onMessageCallbacks.push(cb);
            },

            /*
            Allows you to add an event handler for a specific message type

            @function on
            @param {String} [type] - The message type you want a callback for (mtype property)
            @param {Function} cb - The callback when the the message is recieved
             */

            on: function (type, cb) {
                if(!cb) {
                    this.onMessage(cb);
                } else {
                    if(!onCallbacks.hasOwnProperty(type)) onCallbacks[type] = [];
                    onCallbacks[type].push(cb);
                }
            },

            /*
            Allows you to add an event handler for a specific message type
            that will only fire once

            @function once
            @param {String} [type] - The message type you want a callback for (mtype property)
            @param {Function} cb - The callback when the the message is recieved
             */

            once: function (type, cb) {
                if(!cb) {
                    this.onMessage(cb);
                } else {
                    if(!onceCallbacks.hasOwnProperty(type)) onceCallbacks[type] = [];
                    onceCallbacks[type].push(cb);
                }
            },

            socket: function () {
                // gets the current instance of the socket
                return currSock;
            }
        };
    }

]);
